import React from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { Link } from "react-router-dom";

const SortableRow = React.memo(
  ({ item, index, page, limit, handleStatusChange, openDelete }) => {
    const {
      attributes,
      listeners,
      setNodeRef,
      transform,
      transition,
      isDragging,
    } = useSortable({ id: item.id });

    const style = {
      transform: CSS.Transform.toString(transform),
      transition,
      backgroundColor: isDragging ? "#f7f7f7" : "#fff",
      willChange: transform ? "transform" : "auto",
      zIndex: isDragging ? 1 : "auto",
    };

    return (
      <>
        <tr ref={setNodeRef} style={style}>
          <td
            style={{
              borderLeft:
                item.status === "active" ? "5px solid green" : undefined,
            }}
          >
            <i
              className="fas fa-arrows-alt text-dark fs-16 lh-1 handle me-2"
              style={{ cursor: "grab" }}
              {...attributes}
              {...listeners}
            ></i>
            <b>{(page - 1) * limit + index + 1}.</b>
          </td>
          <td>
            <div className="d-flex align-items-center file-name-icon">
              {item.thumbnail && (
                <a
                  href={item.thumbnail}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span className="avatar avatar-xl border">
                    <img src={item.thumbnail} alt="img" loading="lazy" />
                  </span>
                </a>
              )}
              <div className="lh-0 ms-2 overflow-hidden w-100">
                <h6
                  className="fw-medium mb-1 text-truncate"
                  style={{ maxWidth: "200px" }}
                  title={item.title}
                >
                  <a href="#" className="text-dark text-decoration-none">
                    {item.title}
                  </a>
                </h6>

                <span
                  className="fs--1 text-muted text-truncate d-block"
                  style={{ maxWidth: "180px" }}
                  title={item.slug}
                >
                  {item.slug}
                </span>
              </div>
            </div>
          </td>
          <td>{item.brand}</td>
          <td>{item.category}</td>
          <td>
            <span
              className={`badge ${
                item.productType === "Single" ? "bg-primary" : "bg-secondary"
              }`}
            >
              {item.productType}
            </span>
          </td>

          <td>
            {item.productType === "Variant"
              ? item.sku &&
                item.sku.map((skus, index) => (
                  <span key={index}>
                    {skus}
                    {index < item.sku.length - 1 ? ", " : ""}
                  </span>
                ))
              : item.sku}
          </td>
          <td>
            ₹
            {item.productType === "Variant"
              ? `${item.price.min} - ${item.price.max}`
              : item.price}
            /-
          </td>
          <td>
            {item.stock} {item.unit}
          </td>
          <td className="action-table-data">
            <div className="edit-delete-action">
              {/* <ToggleBtn
                active={item.status === "active"}
                onClick={() =>
                  handleStatusChange(
                    item.id,
                    item.status === "active" ? "inactive" : "active",
                  )
                }
                activeText="Deactivate"
                inActiveText="Activate"
              /> */}

              <Link
                to="/product/add-new"
                state={{ id: item.id }}
                className="me-2 p-2"
              >
                <i className="ti ti-pencil" />
              </Link>
              <span
                className="p-2 box"
                data-bs-toggle="modal"
                data-bs-target="#delete-modal"
                onClick={() => openDelete(item.id)}
              >
                <i className="ti ti-trash" />
              </span>
            </div>
          </td>
        </tr>
      </>
    );
  },
);

export default SortableRow;
